<tabset #tabs>
    
    <tab [heading]="'Video Stream'">
        BEGIN
        <!--<img src="http://192.168.4.4/axis-cgi/mjpg/video.cgi" width="640" height="480" alt="Axis Camera Stream">-->
        <!--<img src="https://localhost:4001/stream" width="1280" height="960" alt="Axis Camera Stream">-->
        <!--<img src="https://localhost:5001/api/Camera/Stream/test" width="1280" height="960" alt="Axis Camera Stream">-->
        <!--<img src="https://localhost:5001/api/FireForesight/GetStream/3/22" width="1280" height="960" alt="Axis Camera Stream">-->
        <!--<video src="rtsp://192.168.6.4/axis-media/media.amp?audiocodec=aac&audiosamplerate=16000&audiobitrate=32000&camera=1&videoframeskipmode=empty&videozprofile=classic&resolution=1920x1080&fps=16&audiodeviceid=0&audioinputid=0&timestamp=0&videocodec=h264">
            NOT SUPPORTED
        </video>-->
        <!--<video width="640" height="480" controls>
            <source src="http://192.168.4.4/axis-cgi/mjpg/video.cgi" type="video/mp4">
            Your browser does not support the video tag.
          </video>-->
          <!--<app-video-player [options]="{autoplay: false, controls: false, sources: [{ src: 'rtsp://192.168.4.4/axis-media/media.amp?audiocodec=aac&audiosamplerate=16000&audiobitrate=32000&camera=1&videoframeskipmode=empty&videozprofile=classic&resolution=1920x1080&fps=16&audiodeviceid=0&audioinputid=0&timestamp=0&videocodec=h264', type: 'rtmp/mp4' }]}"></app-video-player>-->
          <!--<app-video-player [idx]="'abc'" [url]="'rtsp://192.168.4.4/axis-media/media.amp?audiocodec=aac&audiosamplerate=16000&audiobitrate=32000&camera=1&videoframeskipmode=empty&videozprofile=classic&resolution=1920x1080&fps=16&audiodeviceid=0&audioinputid=0&timestamp=0&videocodec=h264'"></app-video-player>-->
          

        END
    </tab>

    <tab [heading]="'General Components'">
        <div class="row mt-3">
            <div class="col-sm-3">
                <div class="card bg-emphasis">
                    <div class="card-header">
                        Time Period
                    </div>
                    <div class="card-body">
                        <app-time-period [period]="'today'" (periodChange)="period = $event" ></app-time-period>
                        <input type="text" class="form-control" [(ngModel)]="period"/>
                    </div>        
                </div>
            </div>
            <div class="col-sm-3">
                <div class="card bg-emphasis">
                    <div class="card-header">
                        Guage - Speedometer
                    </div>
                    <div class="card-body">
                        <app-gauge [gaugeConfig]="gaugeConfig" [gaugeLabel]="'gauge'" [widgetSize]="12" [gaugeType]="'speedometer'" [showValue]="true" [showTitle]="true" ></app-gauge>
        
                    </div>
                </div>  
            </div>
            <div class="col-sm-3">
                <div class="card bg-emphasis">
                    <div class="card-header">
                        Guage - Solid
                    </div>
                    <div class="card-body">
                        <app-gauge [gaugeConfig]="gaugeConfig" [gaugeLabel]="'gauge'" [widgetSize]="12" [gaugeType]="'solid'" [showValue]="true" [showTitle]="true" ></app-gauge>
        
                    </div>
                </div>  
            </div>
        </div>
        

        
    </tab>

    <tab [heading]="'Image Classifier'">
        <app-image-classifier [imageSrc]="'/assets/cover/cover-thumb-3.jpg'"></app-image-classifier>
    </tab>

    <tab [heading]="'Image Overlay'">
        <app-image-overlay #imageOverlay [imageUrl]="'/assets/cover/cover-thumb-3.jpg'" [overlayConfig]="imageOverlayConfig" [allowPointSelection]="true"></app-image-overlay>
    </tab>

    

</tabset>   